import DocumentTitle from 'react-document-title';
import { Route } from 'react-router-dom';
import { routeConfig } from './config';
import AllPages from '../views';
import AllLayouts from '../layouts';
const AllCompoents = {
    ...AllPages,
    ...AllLayouts
};


// export const routes: RouteObject[] = [
//     {
//         path: "/",
//         element: <DefaultLayout />,
//         children: [
//             {
//                 path: "/devfa",
//                 element: <DevPage />,
//                 children: [

//                 ]
//             }
//         ]
//     }
// ];




const route = (route: any) => {
    const subRoutes = route.subs;
    return (
        <Route
            key={route.key}
            path={route.key}
            element={<CusRender route={route} />}
        >
            {
                subRoutes?.length && (
                    subRoutes.map((s: any) => {

                        return (
                            <Route
                                key={s.key}
                                path={s.key}
                                element={<CusRender route={s} />}
                            />
                        );
                    })
                )
            }
        </Route>
    );
};


const CusRender = ({ route }: any) => {
    const Component = route.component && AllCompoents[route.component];

    return (
        <DocumentTitle title={route.title}>
            <Component />
        </DocumentTitle>
    );
}

const createMenu = (r: any) => {

    // console.log(r)
    // const subRoute = (r: IFMenu): any => r.subs && r.subs.map((subR: IFMenu) => (subR.subs ? subRoute(subR) : route(subR)));

    return route(r);//: subRoute(r);

    // const subRoute = (r: any): any => r.subs && r.subs.map((subR: any) => (subR.subs ? subRoute(subR) : route(subR)));

    // return r.component ? route(r) : subRoute(r);
};

const CRouter = () => {

    // @ts-ignore
    const createRoute = (key: string) => routeConfig[key].map(createMenu);

    return (
        <>
            {Object.keys(routeConfig).map((key) => createRoute(key))}
        </>
    )
}

export default CRouter;